module.exports = __webpack_public_path__ + "static/logo-pdf-fba26e8ebef35e5a1c590f3073d4c42c.png";